module.exports = __webpack_public_path__ + "img/IMG_0300_FoamcoreMatted.5bdf5c35.jpg";